import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import FixedFeeHeaderItemsList from "./FixedHeaderItemsList";
import * as api from "../../../api/index";
import { useDispatch } from "react-redux";
import EditFeeHeaderItems from "./EditFeeHeaderItems";
import { toast } from "react-toastify";
import { getFeeHeaderItems } from "actions/fixedFeeHeader.action";

const FixedHeaderItems = ({ item }) => {
  const [isFormOpen, setIsFormOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const vatValue = formData.netAmount * (formData?.vatCode?.rate / 100);
      await api.createFixedFeeHeaderItems(item.fixedFeeHeaderID, [
        {
          ...formData,
          vatCode: formData?.vatCode?.vatCodeId,
          vatValue,
          vatRate: formData?.vatCode?.rate,
        },
      ]);
      toast.success("Item added successfully");
      dispatch(getFeeHeaderItems(item.fixedFeeHeaderID));
      setIsFormOpen(false);
    } catch (error) {
      toast.error("Error occurred while adding item");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-100 d-flex flex-column align-items-end">
      <div className="float-end">
        <Button className="common-btn m-3" onClick={() => setIsFormOpen(true)}>
          Add Item
        </Button>
      </div>
      <FixedFeeHeaderItemsList item={item} />
      {isFormOpen && (
        <EditFeeHeaderItems
          cancelEdit={() => setIsFormOpen(false)}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default FixedHeaderItems;
